export default {"src":"https://static.finncdn.no/_c/travel/_next/static/media/lp.687a3e0e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};